import { render, staticRenderFns } from "./SystemTagNodeAddTalentModal.vue?vue&type=template&id=2f0ad4e8"
import script from "./SystemTagNodeAddTalentModal.vue?vue&type=script&lang=js"
export * from "./SystemTagNodeAddTalentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports